import FormattedMessage from 'I18n/components/FormattedMessage';
import { HelpIcon } from 'foundations-components/transitional/components/HelpIcon';
import { Text } from 'foundations-components/components/Text';
import { List, ListItem } from 'foundations-components/transitional/components/List';
import Rating from './Rating';
import { QualityRatingsByReviewType } from '../constants/RatingAxes';
import { PILL_RATING } from '../constants/RatingTypes';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function QualityDistribution({
  heading,
  hideIfEmptyValue = true,
  labelSize = 'sm',
  qualityRatings,
  reviewType,
  showLabelTooltips = false
}) {
  const qualityRatingsObj = Object.fromEntries(qualityRatings);
  const qualityRatingsOrder = QualityRatingsByReviewType[reviewType];
  const renderQualityRow = (axis, index, self) => {
    const rating = qualityRatingsObj[axis];
    if ((rating == null || rating === 'NaN') && hideIfEmptyValue) {
      return null;
    }
    const renderedLabel = showLabelTooltips ? /*#__PURE__*/_jsx(HelpIcon, {
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `marketplace-ui-reviews.qualityDistribution.tooltips.${reviewType}.${axis}`
      }),
      tooltipPlacement: "right",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `marketplace-ui-reviews.qualityDistribution.labels.${reviewType}.${axis}`
      })
    }) : /*#__PURE__*/_jsx(FormattedMessage, {
      message: `marketplace-ui-reviews.qualityDistribution.labels.${reviewType}.${axis}`
    });
    return /*#__PURE__*/_jsx(ListItem, {
      marginBlockEnd: index === self.length - 1 ? '0' : '400',
      children: /*#__PURE__*/_jsx(Rating, {
        "data-test-id": "rating",
        type: PILL_RATING,
        label: renderedLabel,
        labelSize: labelSize,
        rating: rating
      }, `${axis}_${rating}`)
    });
  };
  return /*#__PURE__*/_jsxs(List, {
    children: [heading && /*#__PURE__*/_jsx(ListItem, {
      marginBlockEnd: "200",
      children: /*#__PURE__*/_jsx(Text, {
        as: "h7",
        children: heading
      })
    }), qualityRatingsOrder.map(renderQualityRow)]
  });
}